import { generateImageSrc } from '@box-utils/media/image.utils';
import './PromoBanner.styles.scss';
import { memo, useEffect, useState } from 'react';
import { PromoBannerProps } from './PromoBanner.types';
import classNames from 'classnames';

const PromoBanner = ({
  className,
  as: HTMLTag = 'div',
  promoBanner,
  ...rest
}: PromoBannerProps) => {
  const [altText, setAltText] = useState(null);
  const [imageUrl, setImageUrl] = useState(null);
  useEffect(() => {
    setImageUrl(generateImageSrc(promoBanner.webImage));
    setAltText(promoBanner.title);
  }, [promoBanner]);

  return (
    <HTMLTag {...rest} className={classNames('promo-banner', className)}>
      <figure className="promo-banner-figure hover-opacity hoverable-animated">
        {imageUrl && <img src={imageUrl as string} alt={altText as string} />}
      </figure>
    </HTMLTag>
  );
};

PromoBanner.displayName = 'PromoBanner';

export default memo(PromoBanner);
